/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_AwaitingInputs */

const en_scene_backstage_awaiting = /** @type {(inputs: Scene_Backstage_AwaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting your approval`)
};

/**
* | output |
* | --- |
* | "Awaiting your approval" |
*
* @param {Scene_Backstage_AwaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_awaiting = /** @type {((inputs?: Scene_Backstage_AwaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_AwaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_awaiting(inputs)
});